<template>
  <div id="main-content">
    <div class="wrapper">
      <jm-crumbs />
      <div class="table-agile-info">
        <jm-toolbar customize-field-name="">
        </jm-toolbar>
        <el-row class="th">
          <el-col :span="6">姓名</el-col>
          <el-col :span="6">
            分配系数
            <el-popover
              placement="right"
              width="250"
              trigger="hover"
              content="0 为不分配，其他值按照比例系数分配（总和不必须为 100%）">
              <el-button type="primary" slot="reference" class="help-button">?</el-button>
            </el-popover>
          </el-col>
          <el-col :span="6">已分配人数</el-col>
        </el-row>
        <el-row class="th-row" v-for="(item, i) in operatorList" :key="i">
          <el-col :span="6"><span v-if="item.testkey === 1" class="red">【测】</span> {{ item.truename }}</el-col>
          <el-col :span="6"><el-input class="jm-input135 percent" v-model="item.percent" />%</el-col>
          <el-col :span="6"><span>{{ item.nums }}</span></el-col>
        </el-row>
        <div style="padding:10px; text-align:center">
          <el-button v-loading="loading" type="primary" size="medium" class="jm-input-common" @click="edit()">保存</el-button>
        </div>
      </div>
    </div>

  </div>
</template>
<style scoped>
.help-button {
  color: #fff;
}
.el-form-item {
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-row.th {
  font-weight: 6;
  background-color: #01142d;
  color: #fff;
  text-align: center;
}
.el-row {
  line-height: 40px;
  padding: 5px 10px;
}
.th-row:nth-child(even) {
  background-color: #e2eaf0;
}
.th-row:last-child {
  background-color: #fff;
}
.percent /deep/ .el-input__inner {
  text-align: right;
}
</style>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';

export default {
  data() {
    return {
      loading: false,
      operatorList: [],
      dict: {
        country: [],
      },
      sum: 0
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
  },
  computed: {},
  methods: {
    dictCountry() {
      return this.dict.country;
    },
    edit() { // 编辑
      this.loading = false;
      this.$http._post({
        url: 'index/operator_allocation/saveAllocation',
        data: this.operatorList,
      }).then((res) => {
        if (res.result === 0) {
          this.$message({
            type: 'success',
            message: '保存成功!'
          });
          this.initOperatorList();
        }
      });
    },
    initOperatorList() {
      this.$http._post({
        url: 'index/operator_allocation/operatorList',
      }).then(({ data }) => {
        this.loading = false;
        this.operatorList = data;
      });
    }
  },
  created() {
    this.initOperatorList();
  }
};
</script>
